module.exports = __webpack_public_path__ + "assets/img/7_348_big.44e56cc9.jpg";